import React, { Component } from "react";
import { connect } from "react-redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Field, reduxForm, reset } from "redux-form";
import Button from "react-bootstrap-button-loader";
import _ from "lodash";

// constants
import { DOMAIN_NAME, DEVELOPMENT_TYPE } from "Constants";
import LocaleStrings from "Languages";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";

// acions
import {
  checkTicketDaschoardStatus,
  fetchSettings,
  updateTicketLiveStatus,
  updateEventSettingsTrackingPixel,
} from "TicketAction";
import { fetchEventDetails } from "DashboardUserAction";

class Ticketdashboard extends BaseComponent {
  constructor(props) {
    super(props);
    this.ticket_url = React.createRef();

    this.state = {
      checked: false,
      copied: false,
      eventsettings_id: null,
      tracking: false,
      tracking_header: "",
      tracking_header_changed: false,
      tracking_footer: "",
      tracking_footer_changed: false,
    };
  }

  componentDidMount() {
    this.props.checkTicketDaschoardStatus(this.props.session);
    this.props.fetchEventDetails(this.props.session);

    this.props.fetchSettings(this.props.session, (response) => {
      let settingData = response.data.resource ? response.data.resource : [];

      if (settingData && settingData.length > 0) {
        this.setState({
          checked: settingData[0].islive,
          eventsettings_id: settingData[0].id,
        });

        if (!_.isEmpty(settingData[0].trackingpixel)) {
          let local_trackingPixel = JSON.parse(settingData[0].trackingpixel);
          this.setState({ tracking_header: local_trackingPixel.header });
          this.setState({ tracking_footer: local_trackingPixel.footer });
        }
      }
    });
  }

  copyUrl = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  redirectUrl = (e) => {
    let step = e.currentTarget.dataset.data_id;
    if (step == "Step1") {
      var path = "managetickets";
      this.props.history.push(`/dashboard/tickets/${path}`);
    } else if (step == "Step2") {
      var path = "payout";
      this.props.history.push(`/dashboard/tickets/${path}`);
    } else if (step == "Step3") {
      var path = "settings";
      this.props.history.push(`/dashboard/tickets/${path}`);
    }
  };

  chnageTicketLiveMode = () => {
    let { settingData } = this.props;
    let status = 1;
    let id = settingData[0].id;
    if (settingData && settingData.length > 0 && settingData[0].islive) {
      status = 0;
    }

    this.props.updateTicketLiveStatus(
      this.props.session,
      status,
      id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(this.props.session);
        }
      }
    );
  };

  handleTrackingToggle = () => {
    const {
        tracking,
        tracking_header,
        tracking_footer,
        tracking_header_changed,
        tracking_footer_changed,
        eventsettings_id,
      } = this.state,
      { session, eventDetails } = this.props;

    // update eventsettings tracingpixel field
    if (tracking && (tracking_header_changed || tracking_footer_changed)) {
      let update_json = {
        header: tracking_header,
        footer: tracking_footer,
      };

      this.props.updateEventSettingsTrackingPixel(
        session,
        eventsettings_id,
        update_json,
        (res) => {
          this.setState({
            tracking_header_changed: false,
            tracking_footer_changed: false,
          });
          if (res.success) {
            let local_res = JSON.parse(res.data.trackingpixel);
            this.setState({
              checked: res.data.islive,
              tracking_header: local_res.header,
              tracking_footer: local_res.footer,
            });
          }
        }
      );
    } else {
      this.props.autofill("ticket_tracking_header", tracking_header);
      this.props.autofill("ticket_tracking_footer", tracking_footer);
    }

    // toogle
    this.setState({ tracking: !tracking });
  };

  render() {
    let { ticketDashboard, eventDetails, settingData, ticketSortbyModal } =
      this.props;
    let { deviceSize } = this.props;

    let seocode =
      eventDetails && eventDetails.seocode
        ? eventDetails.seocode
        : "not-found-seocode";
    var ticketUrl = `https://${seocode}.${DOMAIN_NAME}/t/tickets`;

    let ticketValidationStyle = "steps-icon-not-filled";
    let stripeValidationStyle = "steps-icon-not-filled";
    let settingValidationStyle = "steps-icon-not-filled";

    let ticketIcon = "fa fa-exclamation-circle";
    let stripeIcon = "fa fa-exclamation-circle";
    let settingIcon = "fa fa-exclamation-circle";

    if (ticketDashboard && ticketDashboard.ticket) {
      ticketValidationStyle = "steps-icon-filled";
      ticketIcon = "fa fa-check-circle";
    }
    if (ticketDashboard && ticketDashboard.paymentgateway) {
      stripeValidationStyle = "steps-icon-filled";
      stripeIcon = "fa fa-check-circle";
    }
    if (ticketDashboard && ticketDashboard.setting) {
      settingValidationStyle = "steps-icon-filled";
      settingIcon = "fa fa-check-circle";
    }

    // tracking toggler
    let trackingStyle = "fa fa-chevron-circle-down";
    let trackingActive = "";
    if (this.state.tracking) {
      trackingStyle = "fa fa-chevron-circle-up";
      trackingActive = "activeup";
    }
    //console.log("settingData", settingData);
    return (
      <>
        <div
          className="row ticket-dashboard panel-body scrollable-content"
          // style={{ height: deviceSize.height - 70 }}
        >
          <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12">
            {/* ----- All tickets copy-visit / Ticket sale toggler ----- */}
            {DEVELOPMENT_TYPE === "eventify" &&
            ticketDashboard &&
            ticketDashboard.ticket &&
            ticketDashboard.setting ? (
              <div style={{ marginBottom: 20 }}>
                {/* --- Copy/visit component / Ticket tracking section --- */}
                <div className="ticket-dashboard-ticket-created-page-main-div">
                  {/* - heading - */}
                  <h4 className="heading-para">
                    {LocaleStrings.tickets_dashboard_text_ticket_page_created}
                  </h4>

                  {/* - subtext - */}
                  <p className="promote-para">
                    {
                      LocaleStrings.tickets_dashboard_text_ticket_page_created_sub_title
                    }
                  </p>

                  {/* - component - */}
                  <div className="vertical-align-center gap-2">
                    <div className="">
                      <div className="copy-ticket-page">
                        <div className="ticket-url">{ticketUrl}</div>
                        <CopyToClipboard text={ticketUrl} onCopy={this.copyUrl}>
                          <div className="url-copy">
                            <i
                              className="fa fa-files-o i-custom-m"
                              aria-hidden="true"
                            ></i>
                            {LocaleStrings.button_copy}
                          </div>
                        </CopyToClipboard>
                      </div>
                      {this.state.copied ? (
                        <span style={{ color: "black", float: "right" }}>
                          {LocaleStrings.copied}.
                        </span>
                      ) : null}
                    </div>
                    <div className="">
                      <a
                        href={ticketUrl}
                        target="blank"
                        className="btn btn-custom-blue"
                      >
                        <span aria-hidden="true">
                          {LocaleStrings.button_visit}
                        </span>
                      </a>
                    </div>
                  </div>

                  {/* - Ticket tracking section - */}
                  <div
                    className="dashboard-steps"
                    data-data_id="Step1"
                    onClick={this.handleTrackingToggle}
                    style={{ display: "flex", padding: "16px 0 0" }}
                  >
                    <div style={{ width: "93%" }}>
                      <h6 className="label-mandatory">
                        {
                          LocaleStrings.tickets_dashboard_trackingpixel_caution_text
                        }
                      </h6>
                    </div>
                    <div className={trackingActive} style={{ fontSize: 24 }}>
                      <i className={trackingStyle} aria-hidden="false"></i>
                    </div>
                  </div>
                  {this.state.tracking ? (
                    <div className="row">
                      <div className="col-md-12">
                        <Field
                          name="ticket_tracking_header"
                          label={
                            LocaleStrings.tickets_ticket_form_label_trackingpixel_header
                          }
                          placeholder={
                            LocaleStrings.tickets_ticket_form_ph_trackingpixel
                          }
                          component={this.renderFieldTextarea}
                          labelposition={LABEL_POSITION_TOP}
                          value={this.state.tracking_header}
                          onChange={(e) => {
                            this.setState({
                              tracking_header_changed: true,
                              tracking_header: e.target.value,
                            });
                          }}
                        />
                      </div>
                      <div className="col-md-12">
                        <Field
                          name="ticket_tracking_footer"
                          label={
                            LocaleStrings.tickets_ticket_form_label_trackingpixel_footer
                          }
                          placeholder={
                            LocaleStrings.tickets_ticket_form_ph_trackingpixel
                          }
                          component={this.renderFieldTextarea}
                          labelposition={LABEL_POSITION_TOP}
                          value={this.state.tracking_footer}
                          onChange={(e) => {
                            this.setState({
                              tracking_footer_changed: true,
                              tracking_footer: e.target.value,
                            });
                          }}
                        />
                      </div>
                      <div className="col-md-12 control-label-top">
                        <label className="control-label-top">
                          {LocaleStrings.tickets_trackingpixel_cautionary_text}
                        </label>
                      </div>
                      <div className="col-md-12">
                        <Button
                          style={{ marginTop: 10, marginRight: 15 }}
                          className="button-theme button-theme-blue pull-right"
                          bsStyle="primary"
                          type="button"
                          onClick={this.handleTrackingToggle}
                        >
                          {LocaleStrings.button_save}
                        </Button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                {/* --- Ticket sale live toogler --- */}
                <div className="ticket-dashboard-ticket-sell-main-div">
                  {/* <div className="sell-text">{LocaleStrings.tickets_dashboard_text_ticket_is_live}.</div> */}
                  {this.state.checked ? (
                    <div className="sell-text-checked">
                      <h4 className="heading-para">
                        {
                          LocaleStrings.tickets_dashboard_text_ticket_is_live_title
                        }
                        .
                      </h4>
                      <div className="description-para">
                        {
                          LocaleStrings.tickets_dashboard_text_ticket_is_live_subtitle
                        }
                        .
                      </div>
                    </div>
                  ) : (
                    <div className="sell-text-unchecked">
                      <h4 className="heading-para">
                        {LocaleStrings.wizard_text_ticket_is_off_title}.
                      </h4>
                      <div className="description-para">
                        {LocaleStrings.wizard_text_ticket_is_off_subtitle}.
                      </div>
                    </div>
                  )}

                  <div className="sell-action">
                    <label className="switch-button-container">
                      <input
                        type="checkbox"
                        onChange={this.chnageTicketLiveMode}
                        checked={this.state.checked}
                      />
                      <span className="switch-slider switch-round"></span>
                    </label>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {/* ----- Ticket's setting section ----- */}
            {/* Caution text */}
            <div style={{ fontSize: 14, marginBottom: 10 }}>
              {
                LocaleStrings.tickets_dashboard_text_things_to_do_for_ticket_sell
              }
            </div>

            {/* --- Settings section --- */}
            <div className="template-dashboard-steps-main-div">
              {/* - Setp 1 - */}
              <div
                className="dashboard-steps"
                data-data_id="Step1"
                onClick={this.redirectUrl}
              >
                <div className={ticketValidationStyle}>
                  <i className={ticketIcon} aria-hidden="true"></i>
                </div>
                <div style={{ width: "88%" }}>
                  <h4 className="heading-para">
                    {LocaleStrings.tickets_dashboard_text_add_a_ticket}!
                  </h4>
                  <p className="description-para">
                    {
                      LocaleStrings.tickets_dashboard_text_add_a_ticket_sub_title
                    }
                    .
                  </p>
                </div>
                <div className="steps-icon-arrow">
                  <i
                    className="fa fa-chevron-circle-right"
                    aria-hidden="false"
                  ></i>
                </div>
              </div>

              {/* - Step 2 - */}
              <div
                className="dashboard-steps"
                data-data_id="Step2"
                onClick={this.redirectUrl}
              >
                <div className={stripeValidationStyle}>
                  <i className={stripeIcon} aria-hidden="true"></i>
                </div>
                <div style={{ width: "88%" }}>
                  <h4 className="heading-para">
                    {LocaleStrings.tickets_dashboard_text_connect_with_stripe}!
                  </h4>
                  <p className="description-para" style={{ width: 390 }}>
                    {
                      LocaleStrings.tickets_dashboard_text_connect_with_stripe_sub_title
                    }
                    .
                  </p>
                </div>
                <div className="steps-icon-arrow">
                  <i
                    className="fa fa-chevron-circle-right"
                    aria-hidden="false"
                  ></i>
                </div>
              </div>

              {/* - Step 3 - */}
              <div
                className="dashboard-steps"
                data-data_id="Step3"
                onClick={this.redirectUrl}
              >
                <div className={settingValidationStyle}>
                  <i className={settingIcon} aria-hidden="true"></i>
                </div>
                <div style={{ width: "88%" }}>
                  <h4 className="heading-para">
                    {LocaleStrings.tickets_dashboard_text_complete_setting}!
                  </h4>
                  <p className="description-para">
                    {
                      LocaleStrings.tickets_dashboard_text_complete_setting_sub_title
                    }
                    .
                  </p>
                </div>
                <div className="steps-icon-arrow">
                  <i
                    className="fa fa-chevron-circle-right"
                    aria-hidden="false"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    ticketDashboard: state.ticketDashboard.data,
    eventDetails: state.userEventDetails,
    settingData: state.SettingData.resource,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  checkTicketDaschoardStatus,
  fetchSettings,
  fetchEventDetails,
  updateTicketLiveStatus,
  updateEventSettingsTrackingPixel,
})(
  reduxForm({
    form: "TicketDashboardForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Ticketdashboard)
);
